export default "__VITE_ASSET__944305ed__"